/*
 * EnviAir — Scroll reveal
 *
 * Reveals [data-ea-reveal] elements once as they enter the viewport. Direction
 * and delay come from CSS custom properties set in the markup, so this file
 * only ever toggles a class.
 */
(function () {
  var SELECTOR = '[data-ea-reveal]';
  var READY_CLASS = 'ea-reveal-ready';
  var REVEALED_CLASS = 'is-revealed';

  var root = document.documentElement;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  // Without observer support, or when reduced motion is preferred, leave the
  // page entirely alone — the CSS hidden state is never applied.
  if (reduceMotion.matches || typeof IntersectionObserver === 'undefined') return;

  root.classList.add(READY_CLASS);

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add(REVEALED_CLASS);
        observer.unobserve(entry.target);
      });
    },
    {
      // Start the reveal a little before the element is fully on screen.
      rootMargin: '0px 0px -8% 0px',
      threshold: 0,
    }
  );

  function observe(scope) {
    (scope || document).querySelectorAll(SELECTOR).forEach(function (el) {
      if (el.classList.contains(REVEALED_CLASS)) return;
      observer.observe(el);
    });
  }

  function revealAll(scope) {
    (scope || document).querySelectorAll(SELECTOR).forEach(function (el) {
      el.classList.add(REVEALED_CLASS);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      observe();
    });
  } else {
    observe();
  }

  // Theme editor: sections are re-rendered in place, so pick up new nodes. In
  // the editor a freshly selected section should appear immediately rather
  // than waiting to be scrolled past.
  document.addEventListener('shopify:section:load', function (event) {
    observe(event.target);
  });

  document.addEventListener('shopify:section:select', function (event) {
    revealAll(event.target);
  });
})();
